// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"LoadingInside_loadingWrapper__GsTe2","loaderGif":"LoadingInside_loaderGif__e5Biy"};